import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const ColumnFragment: DocumentNode = gql`
fragment ColumnFragment on Column {
  id
  vizportalId
  luid
  name
  description
  remoteType
  referencedByFieldsConnection {
    totalCount
  }
  referencedByFlowColumnInputFieldConnection {
    totalCount
  }
}
`;
